import z from "zod";

export const AgentPerformanceDashboardSearchSchema = z.object({
    scope: z.enum(["day", "week", "month", "range"]).optional(),
    comparison: z.enum(["none", "previous_period"]).optional(),
    start: z.string().optional(),
    end: z.string().optional(),
    comparisonStart: z.string().optional(),
    comparisonEnd: z.string().optional(),
    team: z.string().optional(),
    teamLeads: z.enum(["true", "false"]).optional(),
});

export type AgentPerformanceDashboardSearch = z.infer<typeof AgentPerformanceDashboardSearchSchema>;
